/*!
 * Habtium: the Habbo universe on your hand.
 *
 * @link https://habtium.es/about
 * @copyright 2006 - 2016 Habtium
 */

/*!
 * Messages object.
 *
 * @author Rodolfo Thiede <rodolfo@habtium.com>
 * @author Víctor Díaz <victor@axiomer.com>
 * @author Fran Torregrosa <fran@axiomer.com>
 */
var Messages = {
	opened: false,
	init: function () {
		$('#btn-messages').click(function () {
			if (Messages.opened)
				Messages.close();
			else
				Messages.open();
		});

		var count = 0;
		Status.add('messages', function (data) {
			if (data.count && data.count.messages != count) {
				if (data.count.messages == 0)
					$('#btn-messages > .count').hide();
				else
					$('#btn-messages > .count').html(data.count.messages).css("display", "block");

				History.notifications += (-count + parseInt(data.count.messages));
				History.reloadNotifications();

				count = data.count.messages;
			}
		});
	},
	changeInfoPage: function (url, title) {
		//history.pushState({path: url}, title, url);
		History.push({path: url}, title, url);
		History.changeTitle(title);
	},
	onChangeHistory: function (e) {
		// e.state.path
		// Pasar a state el username.
	},
	open: function (fromMessages, user) {

		if (user)
			this.userToOpen = user;

		if (!fromMessages) {
			this.prevUrl = window.location.href;
			this.prevTitle = History.title;

			Language.get('messages').then(function (strings) {
				Messages.changeInfoPage('/messages', strings[0] + ' › Habtium');
			});

			window.addEventListener('popstate', this.onChangeHistory);
		}

		Messages.opened = true;
		if ($(document).scrollTop() < 106)
			$('body').animate({scrollTop: '106px'}, 200, next);
		else
			next();

		function next() {

			if (!fromMessages) {
				Header.fixed = true;
				$('#menu').css('position', 'fixed').css('top', 0);
				$('header').hide();
				$('body').css('overflow', 'hidden');

				$('body').append('<div id="pmsg-exterior"></div><div id="pmsg-box"><div id="pmsg-conversations"></div><div id="pmsg-conversation" style="position: relative;"><div style="text-align: center;color: rgba(128, 128, 128, 0.6);font-size: 20px;position: absolute;top: 50%;width: 100%;">Selecciona una conversación</div></div><div class="clear"></div></div>');

				$('#pmsg-exterior').click(function () {
					Messages.close();
				});
			} else {
				$('main').html('<div id="pmsg-box" style="position:;"><div id="pmsg-conversations"></div><div id="pmsg-conversation"></div><div class="clear"></div></div>');
			}


			/* Suggestions */
			$('#pmsg-conversations').html('<div class="box box-small" style="padding: 10px;"><input type="text" id="pmsg-search" placeholder="Empieza a hablar con..."><div style="display:none;" id="autocomplete"></div></div><div class="body"><div style="margin: 15px 0;text-align: center;"><img src="//cdn.habtium.com/management/ajax-loader.gif" style=""></div></div>');
			var hideAutocomplete = function () {
				$('#autocomplete').slideUp('fast').html('');
				$('#pmsg-conversations > .body').show();
			}
			var sefr = $('#pmsg-search').focus();
			$(sefr).keyup(function () {
				var string = $(sefr).val();
				if (string.length > 1) {
					Api.get('/accounts/autocomplete', {string: string, limit: 5}, function (data) {
						if (!data.error) {
							var list = '';
							for (var i in data) {
								Accounts.stored[data[i].id] = data[i];

								list += '<div data-id="' + data[i].id + '" class="ui-account conversation account-suggestion"><div class="avatar" style="background-image:url(' + data[i].avatar + ');"></div><div class="body" style="text-overflow:ellipsis;"><span><h1>' + data[i].username + '</h1> <h2>' + data[i].nick + '</h2></span></div></div>';
							}

							$('#pmsg-conversations > .body').hide();
							$('#autocomplete').html(list + '<div class="clear"></div>').slideDown('fast');
							var responsiveness = Messages.responsiveness;
							$('.account-suggestion').click(Messages.read).click(function () {
								$(sefr).val('');
								hideAutocomplete();
								if (responsiveness.smallMode) responsiveness.enterInConversation();
							});
						}
					});
				} else {
					hideAutocomplete();
				}
			});


			/* Get messages */
			var accounts_ = [];
			Api.get('/messages', {}, function (data) {

				Accounts.getByAccountIfNot(data, function () {
					$('#pmsg-conversations > .body').html('');
					Messages.put(data);
				});

				Messages.autoUpdate();
			});


			/* Responsiveness */
			window.onresize = Messages.responsiveness.adjust;

		}
	},
	responsiveness: {
		smallMode: false,
		enterInConversation: function () {
			$('#pmsg-conversations').hide();
			$('#pmsg-back').show().click(function () {
				$('#pmsg-conversations').show();
			});
		},
		adjust: function (force) {
			var responsiveness = Messages.responsiveness;
			if (force === true) disarrange();
			if (window.innerWidth < 600 && !responsiveness.smallMode) {
				responsiveness.smallMode = true;

				if (Messages.actualConversation) {
					responsiveness.enterInConversation();
				} else {
					$('#pmsg-conversations').show();
				}


				$('.conversation').bind('click.responsiveness', function () {
					responsiveness.enterInConversation();
				});


			} else if (window.innerWidth >= 600 && responsiveness.smallMode) {
				disarrange();
			}

			function disarrange() {
				responsiveness.smallMode = false;
				$('#pmsg-back').hide().unbind('click');
				$('.conversation').unbind('click.responsiveness');
				$('#pmsg-conversations').show();
				$('#pmsg-conversation').show();
			}
		}
	},
	put: function (messages) {
		var list = '';
		for (var i in messages) {
			var account = accounts[messages[i].account.id];

			//list += '<div data-new data-id="'+account.id+'" data-id-message="'+messages[i].id+'" class="conversation'+(messages[i].seen==0 && messages[i].incoming==1 ? ' unseen' : '')+' ui-account" style="width:300px;margin:0 5px 5px 0;'+(messages[i].seen==0 && messages[i].incoming==1 ? 'background-color:rgb(253, 241, 201);' : '')+'"><div class="avatar" style="background-image:url('+ account.avatar +');"></div><div class="body" style="overflow:hidden;text-overflow:ellipsis;width: calc(100% - 70px);"><span>'+ (account.name!=account.nick ? '<h1>'+account.name+'</h1> <h2>'+account.nick+'</h2>' : '<h1>'+account.nick+'</h1>') +'<br /><span>'+messages[i].message+'</span></span></div></div>';


			list += '<div data-new data-id="' + account.id + '" data-id-message="' + messages[i].id + '" class="conversation' + (messages[i].seen == 0 && messages[i].incoming == 1 ? ' unseen' : '') + '" style="' + (messages[i].seen == 0 && messages[i].incoming == 1 ? 'background-color:rgb(253, 241, 201);' : '') + '">\
			<div class="avatar" style="background-image:url(' + account.avatar + ');"></div>\
			<div class="body">' + (account.name != account.nick ? '<h1>' + account.name + '</h1> <h2>' + account.nick + '</h2>' : '<h1>' + account.nick + '</h1>') + '<br /><span>' + messages[i].message + '</span></div>\
			<div class="clear"></div></div>';
		}

		//$('#pmsg-conversations > .body').html(list + '<div class="clear"></div>');
		$('#pmsg-conversations > .body').append(list);

		var newElements = $('#pmsg-conversations > .body').children('[data-new]');
		//if($('.active').hasClass('unseen')) {
		//	$('.active').css('transition', 'background 1s').css('background-color', '');
		//}
		newElements.removeAttr('data-new').click(Messages.read);

		if (this.userToOpen) {
			var user = this.userToOpen;
			/*
			 Accounts.getByName(user, function() {
			 this.read(id);
			 });
			 */
			this.userToOpen = null;
		}

		Messages.responsiveness.adjust(true);

	},
	read: function (id_) {
		if ($('#pmsg-form'))
			$('#pmsg-form').unbind('submit').unbind('scroll');

		var id = $(this).data('id');
		if (id) {
			$('.conversation').removeClass('active');
			$(this).css('transition', 'background 1s').css('background-color', '').addClass('active');
		} else {
			id = id_;
		}
		Messages.actualConversation = id;

		Language.get('messages').then(function (strings) {
			Messages.changeInfoPage('/messages/' + accounts[id].username, accounts[id].name + ' - ' + strings[0] + ' › Habtium');
		});

		$('#pmsg-conversation').html('<div class="head"><span id="pmsg-back" class="glyphicons glyphicons-show-thumbnails-with-lines" style="display: none;"></span><span style="display: table-cell;vertical-align: middle;">' +
			'<h1 style="font-size: 25px;display: inline;"><a href="/' + accounts[id].username + '" style="color: rgb(55, 55, 55);">' + accounts[id].name + '</a></h1>' +
			(accounts[id].name != accounts[id].nick ? ' <h2 style="font-size: 16px;display: inline;">' + accounts[id].nick + '</h2>' : '') +
			'</span></div>' +
			'<div class="body"><div id="pmsg-messages" style="position: absolute;bottom: 0;width: 100%;"></div></div>\
			<div class="footer"><form action="javascript:void(0);" id="pmsg-form" method="post"><div class="avatar" style="background-image:' + $('#avatar-header').css('background-image').replace(/"/g, '\'') + ';"></div><textarea class="form-control" value="" placeholder="Escribe un mensaje a ' + accounts[id].name + '..." maxlength="900" required=""></textarea><input class="button" type="submit" name="message" value="Enviar"></form></div>');

		var locked = true;

		function onSubmit() {
			var isShiftPressed = false;

			$('#pmsg-form').submit(function (e) {
				e.preventDefault();
				var inputs = $('#pmsg-form').children('input,textarea');
				var val = inputs.first().val().trim();

				if (val) {
					inputs.prop('disabled', true);

					Api.post('/messages/' + id, {message: val}, function (data) {
						if (!data.error) {
							inputs.first().val('').focus();
						} else {
						    if (data.error.identifier=='service_create_dm_disabled') {
                                Alert.push([{
                                    type: 'danger',
                                    text: '¡Oops! El servicio de mensajería privada está desactivado temporalmente.',
                                    icon: 'triangle-alert'
                                }]);
                            } else if (data.error.identifier=='privacy_settings_enabled') {
                                Alert.push([{
                                    type: 'danger',
                                    text: '¡Oops! No puedes enviar un mensaje a esta persona por su configuración de privacidad. ¡Pídele que te siga para mantener conversaciones seguras!',
                                    icon: 'triangle-alert'
                                }]);
                            }
                        }
						Messages.update();
						inputs.prop('disabled', false);
						setCaretPosition($('#pmsg-form > textarea'), 0);
					});
				}
			}).children('textarea').keydown(function (e) {

				if (e.which === 16)
					isShiftPressed = true;
				else if (!isShiftPressed && e.which === 13)
					$('#pmsg-form').submit();

			}).keyup(function (e) {
				if (e.which !== 13)
					isShiftPressed = false;

			});
			setCaretPosition($('#pmsg-form > textarea'), 0);

		}

		function getOlderMessages(self) {
			locked = true;
			self.prepend('<div class="loading" style="text-align: center;"><img src="//cdn.habtium.com/management/ajax-loader.gif" style=""></div>');
			var firstMessage = $('.messages-message:first');
			Api.get('/messages/' + Messages.actualConversation, {first: firstMessage.data('id')}, function (messages) {
				if (messages.error)
					self.children('.loading').remove();
				else {
					$('#pmsg-messages').prepend(Messages.getHTMLMessages(messages));
					locked = false;
					self.children('.loading').remove();
					self.scrollTop(firstMessage.offset().top - 230);
				}
			});
		}

		Api.get('/messages/' + id, {limit: 15}, function (messages) {
			if (!messages.error) {
				Accounts.getByAccountIfNot(messages, function () {
					$('#pmsg-messages').html(Messages.getHTMLMessages(messages));
					Messages.scrollDown(true);

					locked = false;

					setTimeout(function () {
						if (($('#pmsg-conversation > .body').height() - $('#pmsg-messages').height()) > 30)
							getOlderMessages($('#pmsg-conversation > .body'));

						$('#pmsg-conversation > .body').scroll(function () {
							var self = $(this);

							if (!locked && self.scrollTop() < 30) {
								getOlderMessages(self);
							}
						});
					}, 1000);

					onSubmit();

				});
			} else
				onSubmit();
		});

	},
	getHTMLMessages: function (messages) {
		// Current date
		var currentDate = new Date();
		var currentDateString = currentDate.getDate() + '/' + currentDate.getMonth() + '/' + currentDate.getFullYear();
		var currentDay = currentDate.getDate();

		var html = '';
		var actualControlDate;

		for (var i = (messages.length - 1); i >= 0; i--) {
			var account = accounts[messages[i].account.id];

			// Message date
			var messageDate = new Date(messages[i].time * 1000);
			var messageDateString = messageDate.getDate() + '/' + messageDate.getMonth() + '/' + messageDate.getFullYear();
			var minute = messageDate.getMinutes();
			if (minute < 10) minute = '0' + minute;

			// Control day
			var toChange = actualControlDate && (messageDateString !== actualControlDate);
			if (toChange) {
				html += '<div class="clear"></div><div class="messages-day">';

				if (messageDateString == currentDateString) {
					// Today
					Language.get('today').then(function (strings) {
						html += strings[0].ucFirst();
					});
				} else if (messageDateString == ((messageDate.getDate() - 1) + '/' + messageDate.getMonth() + '/' + messageDate.getFullYear())) {
					// Yesterday
					Language.get('yesterday').then(function (strings) {
						html += strings[0].ucFirst();
					});
				} else if (messageDate.getDate() > (currentDay - 7) && (messageDate.getMonth() + '/' + messageDate.getFullYear()) == (currentDate.getMonth() + '/' + currentDate.getFullYear())) {
					// In last 7 days
					html += Time.getDayName(messageDate.getDay()).ucFirst();
				} else {
					// Otherwise
					html += messageDateString;
				}

				html += '</div>';
			}

			if (!actualControlDate || toChange)
				actualControlDate = messageDateString;


			html += '<div data-id="' + messages[i].id + '" data-time="" onclick="$(this).children(\'.messages-time\').toggle();" class="messages-message box" style="float: ' + (messages[i].incoming == 1 ? 'left' : 'right') + ';clear: both;">' +
				(messages[i].incoming == 1 ? '<div class="avatar" style="background-image:url(' + account.avatar + ');"></div>' : '') +
				'<div class="text">' + messages[i].message + '<div class="time" style="float: right;color: rgb(168, 168, 168);margin: 6px 0 -2px 10px;font-size: 10px;">' + messageDate.getHours() + ':' + minute + '</div></div><div class="clear"></div></div>';

		}
		return html;
	},
	update: function () {
		var first = $('.conversation').first().data('id-message');
		Api.get('/messages', {last: first}, function (data) {
			for (var i = (data.length - 1); i >= 0; i--) {
				var element = $('.conversation[data-id="' + data[i].account.id + '"]');
				if (element) {
					element.data('id-message', data[i].id).prependTo('#pmsg-conversations > .body')
					element.children('.body').children('span').html(data[i].message);

					if (data[i].incoming == 1 && data[i].seen == 0) {
						element.css('background-color', 'rgb(253, 241, 201)');
						/*setTimeout(function() {
						 element.css('transition', 'background 1s').css('background-color', '');
						 }, 1000);
						 */
					}
				} else {
					Messages.put(data[i]);
				}
			}
		});

		var last = $('.messages-message').last().data('id');
		if (last) {
			Api.get('/messages/' + Messages.actualConversation, {last: last}, function (messages) {
				if (!messages.error) {
					$('#pmsg-messages').append(Messages.getHTMLMessages(messages));
					Messages.scrollDown(true);
				}
			});
		}
	},
	autoUpdate: function () {
		this.interval = setInterval(Messages.update, 5000);
	},
	scrollDown: function (noAnimate) {
		var bodyChat = $('#pmsg-conversation > .body');
		if ($(bodyChat)[0].scrollHeight)
			if (noAnimate)
				bodyChat.scrollTop($(bodyChat)[0].scrollHeight);
			else
				bodyChat.animate({scrollTop: $(bodyChat)[0].scrollHeight});

	},
	close: function () {
		clearInterval(Messages.interval);

		$('#pmsg-exterior').remove();
		$('#pmsg-box').remove();

		$('header').show();
		$('body').css('overflow', '');

		Messages.actualConversation = undefined;
		Messages.opened = false;
		Messages.changeInfoPage(this.prevUrl, this.prevTitle);
	}
};
